import { Controller } from "@hotwired/stimulus"

// Hängt die React-App der Task-Erfassung ein (app/javascript/tyme-react).
// Lädt tyme-react.js beim ersten connect per import() und ruft dessen
// mount/unmount auf, damit die Task-Seite unter Turbo Drive läuft: Turbo
// tauscht den <body>, Stimulus ruft disconnect, und React baut ab. Ersetzt
// das Inline-Startskript (window.initReactApp).
//
//   <div data-controller="react-mount"
//        data-react-mount-src-value="/assets/tyme-react-….js"
//        data-react-mount-projects-value="[…]"
//        data-react-mount-categories-value="[…]"
//        data-react-mount-base-url-value="https://…">
export default class extends Controller {
  static values = { src: String, projects: Array, categories: Array, baseUrl: String }

  // In Tests ersetzbar
  static importModule = (src) => import(src)

  async connect() {
    // Jeder connect bekommt eine eigene Marke. Kommt der Import erst nach einem
    // disconnect (oder einem weiteren connect) zurück, hängt er nichts ein.
    const token = (this.token = {})
    const module = await this.constructor.importModule(this.srcValue)
    if (this.token !== token) return

    this.module = module
    module.mount(this.element, {
      projects: this.projectsValue,
      categories: this.categoriesValue,
      baseUrl: this.baseUrlValue,
    })
  }

  disconnect() {
    this.token = null
    this.module?.unmount(this.element)
    this.module = null
  }
}
